import { useCallback } from 'react';

import { Select, SelectMulti } from 'twyne-new.ui'

import { useCraftProp } from '@/components/builder/utils';

export default function SelectProperty({ name, multi, onChange, creatable, async, ...props }) {
  const { value, setValue } = useCraftProp(name)
  const { value: options, setValue: setOptions } = useCraftProp(`${name}-options`)

  const handleChange = item => {
    onChange && onChange(item)
    if (multi) {
      setValue(item?.map(({ value }) => value))
    } else {
      setValue(item?.value)
    }
  }

  const handleChangeOptions = useCallback(newOptions => {
    setOptions(newOptions)
  }, [setOptions])

  const Tag = multi ? SelectMulti : Select

  return <Tag {...props}
    creatable={creatable}
    value={value}
    async={async}
    onChange={handleChange}
    onChangeOptions={handleChangeOptions}
    options={options || props.options}
    variant='accent'
  />
}
